import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll to top on route changes, EXCEPT when only the language segment
 * (/ar <-> /en) changes. The rest of the path is compared and if it stays
 * identical the scroll position is preserved.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const previousPathRef = useRef(pathname);

  useEffect(() => {
    const stripLang = (p) => p.replace(/^\/(ar|en)(?=\/|$)/, "") || "/";
    const prevStripped = stripLang(previousPathRef.current);
    const nextStripped = stripLang(pathname);

    if (prevStripped !== nextStripped) {
      if (typeof window !== "undefined") {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      }
    }
    previousPathRef.current = pathname;
  }, [pathname]);

  return null;
}
